import React from 'react';

import { LocationBarView } from '../LocationBarView';
import { useStateContext } from '../../context';

export const LocationBar: React.FC = () => {
    const {
        findingCurrentLocation,
        searchInputValue,
        useCurrentLocation,
        setSearchInputValue,
        setSearchTerm,
        setUseCurrentLocation,
    } = useStateContext();

    const handleCurrentLocationButtonClick = () => {
        setUseCurrentLocation(true);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchInputValue(e.target.value);
    };

    const handleSearchButtonClick = () => {
        // First set searchTerm to undefined so the map will update if it has
        // been dragged to a different location but search term is the same
        setSearchTerm(searchInputValue);
        setUseCurrentLocation(false);
    };

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        handleSearchButtonClick();
    };

    return (
        <LocationBarView
            findingCurrentLocation={findingCurrentLocation}
            inputValue={searchInputValue}
            useCurrentLocation={useCurrentLocation}
            onCurrentLocationButtonClick={handleCurrentLocationButtonClick}
            onFormSubmit={handleFormSubmit}
            onInputChange={handleInputChange}
            onSearchButtonClick={handleSearchButtonClick}
        />
    );
};
